import { defineStore } from "pinia";

/**
 * Represents the state managment for the users messaging feature
 */
const useChatStore = defineStore('chat', {
    state: () => ({
        /**The current active conversation details */
        selectedConvoDetails: null as any,
        /**
         * The current playing audio id 
         * (needed to pause audios that may be playing at the same time)  
        */
        currentPlayingAudio: null as any,
        /**The messages being received in real time */
        receivedMessageReults: null as any,
        /**The current active conversation with the messages */
        conversation: null as any,
        /**The information of the pro the user selects to chat with from a different page */
        contactArtisanConvo: null as any,
        /**The number of unread conversations */
        counConversationsUnread: 0,

        // This is used to init the business relationship when the user comes from the business request details page
        initBusinessRelastionship: false,
        businessRequestContext: null as { title: string | null, town: string | null } | null
    }),
    getters: {
        getContactArtisanConvo: (state) => state.contactArtisanConvo,
        getSelectedConvoDetails: (state) => state.selectedConvoDetails,
        getReceivedMessageResults: (state) => state.receivedMessageReults,
        getCountConversationsUnread: (state) => state.counConversationsUnread,
        getConversation: (state) => state.conversation,
        getBusinessRequestContext: (state) => state.businessRequestContext,
        getPartyIds: (state) => {
            let str = state.selectedConvoDetails?.conversation_id // conversation_id example: 'conversation_5-6'
            let number_part = str?.split("_").pop()
            let ids: string[] = number_part?.split("-") ?? []
            let client_id = parseInt(ids[1])
            let worker_id = parseInt(ids[0])
            return {
                client_id,
                worker_id
            }
        },
        getCurrentAudioId: (state) => state.currentPlayingAudio,
        getInitBusinessRelastionship: (state) => state.initBusinessRelastionship,
    },
    actions: {
        setContactArtisanConvo(convo: any) {
            this.contactArtisanConvo = convo
        },
        setConversation(conversation: any) {
            this.conversation = conversation
        },
        setSelectedConvoDetails(convo: any) {
            this.selectedConvoDetails = convo
        },
        setPlayingAudio(id: any) {
            this.currentPlayingAudio = id
        },
        setReceivedMessagesResults(message: any) {
            this.receivedMessageReults = message
        },
        setCounConversationsUnread(count: any) {
            this.counConversationsUnread = count
        },
        setInitBusinessRelastionship(init: boolean) {
            this.initBusinessRelastionship = init
        },
        setBusinessRequestContext(ctx: { title: string | null, town: string | null } | null) {
            this.businessRequestContext = ctx
        },
        cleanUp() {
            this.selectedConvoDetails = null
            this.currentPlayingAudio = null
            this.receivedMessageReults = null
            this.conversation = null
            this.contactArtisanConvo = null
            this.initBusinessRelastionship = false
            this.businessRequestContext = null
        }
    }
})

export default useChatStore